import React from "react";
import SeoHead from "../components/SeoHead";

export default function TermsPage() {
  return (
    <article>
      <SeoHead
        title="Terms of Service"
        description="The terms and conditions for using Paysafi's rent tracking and tenant management platform."
        path="/terms"
      />
      <section className="border-b border-gray-100 bg-gray-50 py-16 dark:border-gray-800 dark:bg-gray-900">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Terms of Service
          </h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: April 2026</p>
        </div>
      </section>
      <section className="py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-4 sm:px-6">
          <Block title="1. Acceptance of terms">
            By creating an account or using Paysafi, you agree to these Terms of Service. If you
            do not agree, you may not use the platform. These terms apply to all users, including
            landlords, property managers, and any other authorised users.
          </Block>
          <Block title="2. Description of service">
            Paysafi is a rent tracking and tenant management platform that enables landlords to
            manage properties, track payments, send reminders via SMS and AI voice calls, and
            maintain tenant records. The service is provided "as is" and may be updated at any time.
          </Block>
          <Block title="3. User accounts">
            You are responsible for maintaining the confidentiality of your account credentials.
            You must provide accurate information during registration and keep it up to date. You
            are responsible for all activity that occurs under your account.
          </Block>
          <Block title="4. Acceptable use">
            You agree not to: use the platform for any unlawful purpose; upload false or misleading
            information; harass tenants through excessive or abusive communications; attempt to
            gain unauthorised access to other accounts or systems; or resell access to the platform
            without our consent.
          </Block>
          <Block title="5. SMS & AI calling">
            When you send SMS reminders or trigger AI voice calls through Paysafi, you represent
            that you have a legitimate landlord and tenant relationship with the recipient. You are
            responsible for compliance with applicable telecommunications regulations in Kenya.
            Standard messaging rates may apply.
          </Block>
          <Block title="6. Payment & billing">
            Plans are billed monthly based on the number of active tenants. You may cancel at any time.
            Refunds are handled on a case by case basis. We reserve the right to change pricing
            with 30 days' notice.
          </Block>
          <Block title="7. Data ownership">
            You retain ownership of all data you enter into Paysafi (property records, tenant
            information, payment records). We do not sell your data to third parties. You may
            export or delete your data at any time through the Settings page.
          </Block>
          <Block title="8. Service availability">
            We strive to maintain 99.9% uptime but do not guarantee uninterrupted service.
            Scheduled maintenance will be communicated in advance.
          </Block>
          <Block title="9. Limitation of liability">
            Paysafi is provided "as is" without warranties of any kind. To the maximum extent
            permitted by law, we shall not be liable for any indirect, incidental, or consequential
            damages arising from your use of the platform.
          </Block>
          <Block title="10. Termination">
            We may suspend or terminate your account if you violate these terms. You may delete
            your account at any time through the Settings page. Upon termination, your data will
            be deleted in accordance with our Privacy Policy.
          </Block>
          <Block title="11. Governing law">
            These terms are governed by the laws of the Republic of Kenya. Any disputes shall be
            resolved through arbitration in Nairobi, Kenya.
          </Block>
          <Block title="12. Contact">
            For questions about these terms, contact us at{" "}
            <a href="mailto:botibongasolutions@gmail.com" className="font-medium text-indigo-600 hover:text-indigo-700">
              botibongasolutions@gmail.com
            </a>.
          </Block>
        </div>
      </section>
    </article>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{children}</p>
    </div>
  );
}
